import React from 'react';
import { ArrowRightIcon, ListChecksIcon } from 'lucide-react';
import { LazyYouTubeEmbed } from './LazyYouTubeEmbed';
import { contact } from '../data/contact';
const facts = [{
  value: '5+ Jahre',
  label: 'Close-Spezialisierung'
}, {
  value: '150+',
  label: 'implementierte Systeme'
}, {
  value: '0 €',
  label: 'Werbebudget – Kunden kommen über Empfehlung'
}, {
  value: 'Mo–So',
  label: 'erreichbar von 9 bis 21 Uhr'
}];
export function Hero() {
  return <section id="video" className="relative pt-28 lg:pt-36 pb-12 lg:pb-16 bg-[#0a0e1a] scroll-mt-16" data-id="element-140" data-mp="127ec173d7daa">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141" data-mp="sb1axo5hpx5i">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center" data-id="element-142" data-mp="s9ghy2ytqm9r">
          <div className="lg:col-span-5" data-id="element-143" data-mp="nbez9j5b8oyt">
            <p className="text-[#ff6b35] text-sm font-semibold mb-5" data-id="element-144" data-mp="nekqp51ew2xp">
              Close CRM Agentur-Vergleich
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-[3.25rem] font-bold text-white leading-[1.1] mb-6" data-id="element-145" data-mp="381xlmzcsr4ap">
              Die beste Close&nbsp;CRM Agentur finden – ohne die typischen
              Fehler.
            </h1>
            <p className="text-lg text-gray-400 mb-6 leading-relaxed" data-id="element-146" data-mp="3o6ap3tgx82yw">
              Du willst Close CRM einrichten lassen oder deine Agentur
              wechseln? Insider-Wissen aus über 150 Close-Implementierungen:
              was bei anderen Kunden schiefgelaufen ist, und die 6 Punkte, die
              du vor der Unterschrift prüfen solltest.
            </p>
            <p className="text-sm text-gray-500 border-l-2 border-[#ff6b35]/60 pl-4 mb-8 leading-relaxed" data-id="element-147" data-mp="3599i633t3ssb">
              Ja, wir sind selbst eine Close-Agentur – und damit voreingenommen.
              Genau deshalb kennen wir den Markt und sagen dir offen, worauf es
              ankommt.
            </p>
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-148" data-mp="2hincujl6smm0">
              <a href="#checkliste" className="inline-flex items-center justify-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-7 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap" data-id="element-149" data-mp="2hlj8u2dh517t">
                <ListChecksIcon className="w-5 h-5" data-id="element-150" data-mp="najg5kfzo7df" />
                Zur Checkliste
              </a>
              <a href="#termin" className="inline-flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white px-7 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap" data-id="element-151" data-mp="id02omr47ymj">
                Erstgespräch buchen
                <ArrowRightIcon className="w-5 h-5" data-id="element-152" data-mp="162capjapi0n9" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-153" data-mp="11154hoo7p9ip">
            <div className="relative aspect-video rounded-2xl overflow-hidden border border-white/10 bg-[#111827] shadow-2xl" data-id="element-154" data-mp="x1eevoaf8zfr">
              <LazyYouTubeEmbed videoId={contact.youtubeVideoId} title="Close CRM Agentur Vergleich: Die beste Close CRM Agentur – Justus Kraft" data-id="element-155" data-mp="3lu04j5ufbd1u" />
            </div>
            <p className="mt-3 text-sm text-gray-500" data-id="element-156" data-mp="1xam6asypfuzz">
              Justus Kraft, Founder von CRM Kraft, über die wichtigsten
              Faktoren bei der Wahl einer Close-Agentur.
            </p>
          </div>
        </div>

        <dl className="mt-14 lg:mt-20 pt-8 border-t border-white/5 grid grid-cols-2 lg:grid-cols-4 gap-y-6 gap-x-8" data-id="element-157" data-mp="267whkebivk4w">
          {facts.map(fact => <div key={fact.value} data-id="element-158" data-mp="2g0lr33niinxl">
              <dt className="sr-only" data-id="element-159" data-mp="2fzj2j2dnwxku">{fact.label}</dt>
              <dd className="text-2xl font-bold text-white" data-id="element-160" data-mp="2kydrkm283ide">{fact.value}</dd>
              <dd className="text-sm text-gray-400 mt-1" data-id="element-161" data-mp="2p0h6jko3p53f">{fact.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}